import React from 'react';
import { Icon, Input, Button, Dropdown, Grid,Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';


function RenderCard({ param1, param2 }) {
  return (
    <div>
      <Card className="custom-card mb-3" style={{background: '#fff'}}>
        <Card.Content style={{width: '108%'}}> <Card.Header style={{fontSize:'17px', textAlign:'center', color:'#0a2352'}}>{ param1}</Card.Header></Card.Content>
          <Card.Content style={{fontSize:'1.8rem'}}>
            <Card.Description style={{fontWeight:'700'}}><span>{param2}</span> </Card.Description>
          </Card.Content>
        </Card>
    </div>
  );
}

export default RenderCard;